import moment from "moment";

export function DateAddDays(days: number): Date {
    let date = new Date();
    date.setDate(date.getDate() + days);
    return date;
}

export function HoursToMinutes(hours: number): number {
    return hours * 60;
}

export function convertUTCDateToLocalDate(date: Date): string {
    let stillUtc = moment.utc(date).toDate();
    let local = moment(stillUtc).local().format("hh:mm A DD/MM/yyyy");
    return local;
}

export function toGBDate(iso?: string | null) {
    if (!iso) return null;
    const d = new Date(iso);
    return isNaN(d.getTime()) ? null : d.toLocaleDateString("en-GB");
}
